import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { CUSTOM_RELATIONS_QUERY_KEY } from './useFetchAnnotationCustomRelations';

export const useCreateCustomRelation = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      name,
      parent,
      annotations,
    }: {
      name: string;
      parent: Url;
      annotations: Url[];
    }) =>
      api.request(
        endpoints.relations.create({
          type: 'custom',
          name,
          parent,
          annotations,
        })
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CUSTOM_RELATIONS_QUERY_KEY],
      });
    },

    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'features.customRelations.errors.createRelation',
        }),
      });
    },
  });
};
